import React from 'react'
import type { ClientLibraryClient } from 'types/client-library'
import LibraryClientNameSvg from 'assets/icons/check-in-star.svg'
import { getInitials } from '@disco/utils/string-utils'
import UserAvatar from 'components/ui/user-avatar'
import styles from './index.module.css'

const getNodeRight = (status: ClientLibraryClient['status']) => {
  switch (status) {
    case 'pre-approved supervisor':
      return (
        <div className={styles.clientLibrariesNameIconContainer}>
          <LibraryClientNameSvg width="16px" height="16px" />
        </div>
      )

    default:
      return undefined
  }
}

const ClientLibrariesName = ({
  status,
  first_name,
  last_name,
}: {
  status: ClientLibraryClient['status']
  first_name: string | null | undefined
  last_name: string | null | undefined
}): React.ReactElement<'div'> => {
  return (
    <div className={styles.clientLibrariesName}>
      <UserAvatar
        className={styles.clientLibrariesNameAvatar}
        name={getInitials([first_name, last_name].join(' '))}
        size="24px"
        fontSize="11px"
        nodeRight={getNodeRight(status)}
      />
      <span className={styles.clientLibrariesNameLabel}>
        {[first_name, last_name].join(' ')}
      </span>
    </div>
  )
}

export default ClientLibrariesName
